module.exports = __webpack_public_path__ + "img/shkitin.6e624230.jpg";